/**
 * Replace every character matched by `mask` with `maskChar`, one mask
 * character per hidden character so the string length is preserved. The whole
 * regex match is replaced, so lookahead and capture-group patterns work.
 *
 * Pass a global (`g`) regex to mask every occurrence (e.g. `/\d(?=\d{4})/g`);
 * without the `g` flag only the first match is hidden.
 */
export function maskValue(value: string, mask: RegExp, maskChar = '•'): string {
  return value.replace(mask, (match) => maskChar.repeat(match.length));
}
